/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Pocket = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z" }],
    ["polyline", { points: "8 10 12 14 16 10" }]
  ]
];

export { Pocket as default };
//# sourceMappingURL=pocket.js.map
